<template>
  <div style="width: 100%;">
    <!-- <h1>上传新的喂食器固件</h1> -->

    <el-form ref="fw_form" :model="form" :inline="false" :rules="rules" label-position="left" label-width="200px"
        style="width: 50%; margin-left: 0%;">
      <!-- <el-form-item label="硬件版本号" prop="hwver">
        <el-input-number v-model="form.hwver" :min="10" :max="255" label="硬件版本号10-255" :precision="0"></el-input-number>
      </el-form-item> -->
      <el-form-item label="固件版本号" prop="fwver">
        <el-input-number v-model="form.fwver" :min="1" :max="255" label="硬件版本号1-255" :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="最低固件版本号" prop="min_fwver">
        <el-input-number v-model="form.min_fwver" :min="0" :max="255" label="硬件版本号0-255" :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="升级说明" prop="desc">
        <el-input type="textarea" v-model="form.desc" clearable size="mini" style="width: 90%;" placeholder="升级版本的说明注释信息"></el-input>
      </el-form-item>
      <el-form-item label="强制更新">
        <el-switch v-model="form.force"></el-switch>
      </el-form-item>
      <el-form-item label="选择固件文件" prop="upload">
        <el-upload class="upload-demo" ref="upload" :accept="acceptFile()" action="" :http-request="httpRequest" :auto-upload="false"
            :on-change="fileChange" :on-remove="fileRemove" :file-list="fileList">
          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">只能上传hex文件</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="submit" type="primary">上传固件</el-button>
    </span>
  </div>
</template>

<script lang="js">
import { uploadBeltFW } from '@/api';
import http from '@/utils/request';
import Vue from 'vue';
export default Vue.extend({
  name: "feederupfw",
  props: {},
  data() {
    var validateFile = (rules, value, callback) => {
      if(this.fileList.length < 1) {
        callback(new Error("请选择文件"))
      } else {
        callback()
      }
    }

    return {
      fileList: [],

      form: {
        fwver: 1,
        min_fwver: 0,
        desc: "",
        force: false
      },
      
      rules: {
        fwver: [
          {required: true, message: '硬件版本号1-255'}
        ],
        min_fwver: [
          {required: true, message: '硬件版本号0-255'}
        ],
        desc: [
          {required: true, message: '请填写描述信息'}
        ],
        upload: [
          {required: true, validator: validateFile, message: '请选择上传文件'}
        ]
      }
    }
  },
  computed: {},
  methods: {
    uploadFeederFW(fd, config) {
      // config.headers
      return http.post('https://test.chongyueyue.cn/smart_feeder/firmware/add_firmware',
        fd, config
      )
    },
    submit() {
      this.$refs.fw_form.validate((valid) => {
        console.log(valid);
        console.log("Filelist = ", this.fileList)
        if (valid) {
          this.$refs.upload.submit();
        }
      })
    },

    open2() {
      this.$message({
        message: '上传成功',
        type: 'success'
      });
    },

    open4(errStr) {
      this.$message.error('上传失败:' + errStr);
    },

    httpRequest(param) {
      console.log('httpRequest param: ', param)
      var fileObj = param.file
      var fd = new FormData()
      fd.append('firmware_version', this.form.fwver)
      fd.append('min_firmware_version', this.form.min_fwver)
      fd.append('firmware_file', fileObj)
      fd.append('description', this.form.desc)
      fd.append('is_force_update', this.form.force)
      var config = {headers: {}, withCredentials: false}

      var that = this
      this.uploadFeederFW(fd, config).then(res => {
        console.log('uploadFeederFW resp: ', res)
        if (res.data.code == 200) {
          that.open2()
        } else {
          that.open4(res.data.msg + "[" + res.data.code + "]");
        }
      })
    },

    fileChange(file, fileList) {
      this.fileList = [file]
      console.log('fileChange: ', file, this.fileList)
    },

    fileRemove(file, fileList) {
      this.fileList = [];
      console.log("fileRemove: ", file, this.fileList);
    },

    acceptFile() {
      return ".hex"
    }
  },
  watch: {},

  // 组件周期函数--监听组件挂载完毕
  mounted() {},
  // 组件周期函数--监听组件数据更新之前
  beforeUpdate() {},
  // 组件周期函数--监听组件数据更新之后
  updated() {},
  // 组件周期函数--监听组件激活(显示)
  activated() {},
  // 组件周期函数--监听组件停用(隐藏)
  deactivated() {},
  // 组件周期函数--监听组件销毁之前
  beforeDestroy() {},
}) 
</script>

<style scoped></style>